<template>
  <el-dialog title="增加镜架类品牌" :visible.sync="dialogVisible"  custom-class="max-dialog" width="500" center :append-to-body="true"
             :close-on-click-modal="false" :before-close="beforeClose">
    <div class="formBox">
      <el-form ref="infoForm" :model="formData" :rules="rules" label-width="100px" size="medium">
        <!--<el-form-item label="所属类别：" prop="class">-->
          <!--<el-cascader style="width:100%" v-model="formData.class" :options="options"></el-cascader>-->
        <!--</el-form-item>-->
        <el-row :gutter="20">
          <el-col :span="8">
        <el-form-item label="品牌名称：" prop="name">
          <el-input v-model="formData.name" maxlength="30" show-word-limit style="width: 300px"></el-input>
        </el-form-item>
          </el-col>
          <el-col :span="5">
        <el-form-item label="产地：" prop="place">
          <el-input v-model="formData.place" show-word-limit style="width: 120px"></el-input>
        </el-form-item>
          </el-col>
          <el-col :span="5">
        <el-form-item label="默认单价：" prop="defaultprice">
          <el-input-number v-model="formData.defaultprice" :controls="false" style="width: 120px" ></el-input-number>
        </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" @click="save" :loading="loading">确定增加</el-button>
          </el-col>
        </el-row>
        <!--<el-form-item label="logo图片：">-->
          <!--<el-upload action=" ">-->
            <!--<button class="uploadBtn">点击上传<i class="iconfont icontupianshangchuan"></i></button>-->
          <!--</el-upload>-->
        <!--</el-form-item>-->
      </el-form>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>启用品牌</span>
        </div>
        <el-table
          :data="tableData.filter(o=>o.categoryname.toLowerCase().includes(formData.name.toLowerCase()))"
          :height="500"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            type="index"
            width="60"
            label="序号"
            align="center">
          </el-table-column>
          <el-table-column
            prop="codeandname"
            label="名称"
            align="left" width="280"
            header-align="center">
          </el-table-column>
          <el-table-column
            label="子分类"
            align="left"
            header-align="center">
            <template slot-scope="scope">
              <el-tag
                :key="item.categorycode"
                v-for="item in scope.row.children" style="cursor: pointer"
                closable
                :disable-transitions="false" @click="editChild(item)"
                @close="handleClose(scope.row,item)">
                {{item.categoryname}} {{item.place}} {{item.defaultprice}}
              </el-tag>
              <el-button class="button-new-tag" size="small" @click="showInputAdd(scope.row)">增加子类</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="place"
            label="产地"
            align="left" width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="defaultprice"
            label="默认单价"
            align="left"  width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            label="商品拆分方案"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.onecolor" size="mini" @change="saveOnecolor(scope.row)">
                <el-option label="按型号分" value="0"></el-option>
                <el-option label="按色号分" value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="sortnum"-->
            <!--label="排序号"-->
            <!--align="center"-->
            <!--header-align="center"-->
            <!--width="140">-->
          <!--</el-table-column>-->
          <el-table-column
            label="操作"
            width="150"
            align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)" >编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>历史品牌</span>
        </div>
        <el-table
          :data="tableDataHis.filter(o=>o.categoryname.toLowerCase().includes(formData.name.toLowerCase()))"
          :height="400"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            type="index"
            width="60"
            label="序号"
            align="center">
          </el-table-column>
          <el-table-column
            prop="codeandname"
            label="名称"
            align="left" width="280"
            header-align="center">
          </el-table-column>
          <el-table-column
            label="子分类"
            align="left"
            header-align="center">
            <template slot-scope="scope">
              <el-tag
                :key="item.categorycode"
                v-for="item in scope.row.children" style="cursor: pointer"
                closable
                :disable-transitions="false" @click="editChild(item)"
                @close="handleClose(scope.row,item)">
                {{item.categoryname}} {{item.place}} {{item.defaultprice}}
              </el-tag>
              <el-button class="button-new-tag" size="small" @click="showInputAdd(scope.row)">增加子类</el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="place"
            label="产地"
            align="left" width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="defaultprice"
            label="默认单价"
            align="left"  width="100"
            header-align="center">
          </el-table-column>
          <el-table-column
            label="商品拆分方案"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.onecolor" size="mini" @change="saveOnecolor(scope.row)">
                <el-option label="按型号分" value="0"></el-option>
                <el-option label="按色号分" value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--<el-table-column-->
          <!--prop="sortnum"-->
          <!--label="排序号"-->
          <!--align="center"-->
          <!--header-align="center"-->
          <!--width="140">-->
          <!--</el-table-column>-->
          <el-table-column
            label="操作"
            width="230"
            align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)" >编辑
              </el-button>
              <el-button
                size="mini"
                @click="handleOpen(scope.$index, scope.row)" >启用
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div slot="footer">
      <el-button  @click="cancel">关闭</el-button>
      <BrandEdit ref="BrandEdit" @bindGrid="bindGrid"></BrandEdit>
    </div>
  </el-dialog>
</template>
<script>
  import BrandEdit from './BrandEdit.vue'
  import {saveData, getDetail,getListData,getListallData,deleteData,listGoodsRight,batchsaveGoodsRight} from '@/api/set/jxcgoodscategory';

export default {
  components: { BrandEdit },
  data() {
    let validName = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        var hasValue = false;
        var hasHisValue = false;
        for (let i in this.parentCat.children) {
          if (this.parentCat.children[i].text == value) {
            hasValue = true;
            break;
          }
        }
        if(!hasValue){
          for (let i in this.tableData) {
            if (this.tableData[i].categoryname == value) {
              hasValue = true;
              break;
            }
          }
          if(!hasValue){
            for (let i in this.tableDataHis) {
              if (this.tableDataHis[i].categoryname == value) {
                hasValue = true;
                hasHisValue=true;
                break;
              }
            }
          }
        }

        if (hasValue)
          callback(new Error('品牌名称已'+(hasHisValue?'在历史品牌中':'存在')+'，不允许重复添加！'))
        else
          callback()
      }
    }

    return {
      loading:false,
      dialogVisible: false,
      tableData:[],
      tableDataHis:[],
      formData: {
        class: '',
        name: '',
        place: '',
        defaultprice: '',
      },
      parentCat:{},
      rules: {
        name: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' },
          { required: true, validator: validName, trigger: 'blur' }
        ],
      },
    }
  },
  methods: {
    handleClose(row,tag) {
      this.handleDelete(tag);
    },
    editChild(row){
      this.$refs.BrandEdit.show(row.categorycode,{children:[]},row.children)
    },
    showInputAdd(row) {
      this.$refs.BrandEdit.show('',{categorycode:row.categorycode,defaultprice:row.defaultprice,place:row.place,children:[]},row.children)
    },
    beforeClose(done){
      //刷新列表
      this.$emit('bindGrid');
      done();
    },
    show(item) {
      this.loading = false;
      this.formData.name = ''
      this.formData.place=''
      this.formData.defaultprice=''
      this.parentCat = item;
      this.dialogVisible = true;
      this.bindGrid();
    },
    bindGrid(){
      //自己添加的商品
      getListData({
        categoryname: '',
        allcat:'9',
        categorycode: this.parentCat.id,
      }).then(response => {
        this.tableData = []
        this.tableDataHis = []
        this.setRight(response.data.obj.rows);
      }).catch((error) => {
        console.log(error)
      });
    },
    bindSecondGrid(items,codeslist) {
      //自己添加的商品
      getListallData({
        categoryname: '',
        categorylenght: 12,
        allcat: '9',
        category: this.parentCat.id,
      }).then(response => {
        var children = response.data.obj.rows
        for (let i in items) {
          if (items[i].canedit == 1) {
            items[i].children = []
            for (let j in children) {
              if (children[j].categorycode.indexOf(items[i].categorycode) == 0) {
                items[i].children.push(children[j]);
              }
            }
            if (!items[i].onecolor)
              items[i].onecolor = '0';
            else
              items[i].onecolor = items[i].onecolor.toString();

            var filtercode = codeslist.find(a => a.categorycode == items[i].categorycode);
            console.log(filtercode)
            if (filtercode && filtercode.categorycode == items[i].categorycode) {
              this.tableData.push(items[i])
            } else {
              this.tableDataHis.push(items[i])
            }
          }
        }
      }).catch((error) => {
      });
    },
    setRight(items){
      listGoodsRight({}).then(reponse=>{
        this.bindSecondGrid(items,reponse.data.obj);
      })
    },
    handleOpen(index, row) {
      batchsaveGoodsRight({categorycodes: row.categorycode}).then(response => {
        this.$message({
          message: '已更新成 启用 状态！',
          type: 'success'
        })
        this.bindGrid();
      })
    },
    handleEdit(index, row) {
      this.$refs.BrandEdit.show(row.categorycode,this.parentCat,this.tableData)
    },
    saveOnecolor(row){
      saveData({categorycode:row.categorycode,onecolor:row.onecolor}).then(response=>{
        if (response.data.code === 0) {
          this.$message({
            message: '修改“商品拆分方案”成功！',
            type: 'success'
          })
          this.$emit('bindGrid');
        }
      })
    },
    handleDelete(row) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData({categorycode: row.categorycode}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              type: 'success',
              message: response.data.msg
            });
            this.bindGrid();
          } else {
            this.$message({
              type: 'error',
              message: response.data.msg
            });
          }
        })
      }).catch(() => {
      });
    },
    cancel() {
      this.$emit('bindGrid');
      this.dialogVisible = false;
    },
    save() {
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          this.loading=true;
          saveData({  //表单数据
            categorycode: '',
            parentdserial: this.parentCat.id,
            categoryname: this.formData.name,
            enabled: 1,
            sortnum: 0,
            queryproperty: '',
            formproperty: '',
            trademark: '',
            openurl: "",
            advertisement: '',
            tenantid: '',
            filltemplate: '',
            setofbooks: '',
            place: this.formData.place,
            onecolor: (this.tableData.length > 0) ? this.tableData[0].onecolor : 0,
            defaultprice: this.formData.defaultprice
          }).then(response=>{
            if (response.data.code === 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              //this.dialogVisible = false;
              this.formData.name = ''
              this.formData.place=''
              this.formData.defaultprice=''
              this.loading = false;
              this.bindGrid();
            } else {
              this.loading=false;
              this.$message.error(response.data.msg);
            }
          })
        }
      });
    }
  }
}
</script>
<style scoped>
/*.formBox {*/
  /*padding: 0 120px;*/
  /*/deep/ .el-form-item {*/
    /*margin-bottom: 24px;*/
    /*&:last-child {*/
      /*margin-bottom: 0;*/
    /*}*/
  /*}*/

  /*.uploadBtn {*/
    /*@include btnCommon(primaryPlain, 36px, 92px, 4px, 12px);*/
  /*}*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/childComp/BrandAdd.vue